/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React, { useContext, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import InputField from 'components/Form/InputField';
import { Form, Formik, Field, FieldArray } from 'formik';
import ScheduleInitialExport from 'components/ScheduleInitialExport';
import * as yup from 'yup';
import { Button, SelectField } from 'components/index';
import { CacheManager, MessageCenter } from 'utils';

export default function Test2Page() {
  const cache = new CacheManager();
  const history = useHistory();
  const url = "https://www.whosampled.com/Amerigo-Gazaway/It-Ain%27t-Nothing-Like/"

  function handleClick(){
   window.open("https://www.whosampled.com/Amerigo-Gazaway/It-Ain%27t-Nothing-Like/");
  }
  return (

<>
    <Button primary onClick={()=> handleClick()}>
      me clinca
    </Button>
    <Formik initialValues={{ teste: '' }} onSubmit={(e) => console.log(e)}>
      {formikProps => (
        <Form>
          <Field mask={
            {
              type: "currency",
              mask: '$ num',
              blocks: {
                /* num: {
                  mask: Number,
                  scale: 5,  // digits after point, 0 for integers
                  signed: false,  // disallow negative
                  thousandsSeparator: '',  // any single char
                  padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                  normalizeZeros: true,  // appends or removes zeros at ends
                  radix: '.',  // fractional delimiter
                  min: 0,
                  max: 100
                }, */
                
                num: { 
                  mask: Number,
                  scale: 2,  // digits after point, 0 for integers
                  signed: false,  // disallow negative
                  thousandsSeparator: ' ',  // any single char
                  padFractionalZeros: false,  // if true, then pads zeros at end to the length of scale
                  normalizeZeros: true,  // appends or removes zeros at ends
                  radix: '.'
                }
              }
              
            }} component={InputField} name={'teste'} /* onChange={formikProps.handleChange} */></Field>
          <button type='submit'>Teste</button>
        </Form>
      )}

    </Formik>

{    /* <button onClick={async ()=>{
      let message = await cache.getMessage("TESTE","en","356",token).catch(e => console.log(e));
      console.log(message);
    }}>teste</button> */}
    </>
  )
}